<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="technological-banner">
      <div style="position: relative">
        <p class="sp1">产学研，硬科技</p>
        <p class="sp2">交达凝聚联合高校、企业、机构等人才，以“专精特新”为引领，倾注热情实践“产学研融政”协同创新</p>
      </div>
    </div>

    <div class="technological1">
      <div class="title1">创新发展</div>
      <div class="content1">20
        余年来，得益于国内基础建设的快速发展和巨大成就的同时，团队秉承着“敬天爱人、需求引领”的根本理念，高度聚焦工程建设的品质提升工作。依托科技部、交通部等重大项目的研究基础，团结与凝聚了工程建设领域、先进制造领域和信息技术领域的高校、企业、机构等人才，以“专精特新”精神为引领，倾注热情实践“产学研融政”协同创新，用持续进化的产品和深入人心的服务，把研发和创新落在工程建设的大地之上。
      </div>
      <div class="flex-center technological-box1-t1" style="margin-top: 0.4rem">
        <img class="img1" src="@/assets/imgs/technological/2.png"/>
        <span class="img3" style="    top: 0.35rem;left: 0.3rem;width: 1.8rem;">产学研、硬科技</span>
        <img class="img2" src="@/assets/imgs/technological/3.png" style="    top: 0.3rem;right: 2.3rem;"/>
        <span class="img2" style="    top: 0.2rem;right: 0.4rem;width: 1.8rem;">新方案、新价值</span>
        <img class="img3" src="@/assets/imgs/technological/4.png" style="top: 0.45rem;left: 2.1rem;"/>
        <span class="img2" style="top: 0.7rem; right: -0.7rem;width: 2.4rem;">高度聚焦，专精特新</span>
        <img class="img2" src="@/assets/imgs/technological/3.png" style="    top: 0.8rem;right: 1.8rem;"/>
        <img class="img3" src="@/assets/imgs/technological/4.png" style="    top: 1.1rem;left: 1.7rem;"/>
        <span class="img3" style="top: 1rem; left: -0.5rem;width: 2.4rem;">敬天爱人，需求引领</span>
      </div>
    </div>

    <div class="technological-box2">
      <p class="box2-t1">创新体系</p>
      <div class="box2-ul">
        <div class="box2-li">
          <div class="box2-li-header flex" style="align-items: center">01 <span class="line"></span> 团队</div>
          <ul>
            <li>多学科跨界融合于土木工程</li>
            <li>聚集顶尖高新技术专业人才</li>
          </ul>
          <div class="box2-lis"></div>
        </div>

        <div class="box2-li">
          <div class="box2-li-header flex" style="align-items: center">02 <span class="line"></span> 平台</div>
          <ul>
            <li>凝聚高校、央企、政府机构</li>
            <li>长期聚焦预应力的研究实践</li>
            <li>构建开放式创新的专业生态</li>
          </ul>
          <div class="box2-lis"></div>
        </div>
        <div class="box2-li">
          <div class="box2-li-header flex" style="align-items: center">03 <span class="line"></span> 文化</div>
          <ul>
            <li>至善、使命、热爱、聚焦、硬科技</li>
            <li>“产、学、研、融、政”协同创新</li>
            <li>新理念、新方案、新装备、新业态</li>
          </ul>
          <div class="box2-lis"></div>
        </div>
        <div class="box2-li">
          <div class="box2-li-header flex" style="align-items: center">04 <span class="line"></span> 机制</div>
          <ul>
            <li>利他主义的多方共赢机制</li>
            <li>高度聚焦的产业科技研发</li>
            <li>跨界融合的技术整合机制</li>
            <li>持续迭代的研究开发模式</li>
          </ul>
          <div class="box2-lis"></div>
        </div>
      </div>
    </div>

    <div class="technological-box3">
      <img class="img1" src="@/assets/imgs/wap/18.png"/>
      <img class="img2" src="@/assets/imgs/wap/1.png"/>
    </div>

    <div class="technological-box7">
      <div class="box7-title">部分科研项目展示</div>
      <div class="box7-ul">
        <div class="box7-li" v-for="item in list2">
          <img src="@/assets/imgs/technological/21.png">
          <div class="text1">{{item.type}}</div>
          <div class="box7-li-text">{{item.name}}</div>
          <div class="box7-li-text2" v-for="items in item.tag1">{{items}}</div>
        </div>
      </div>
    </div>
    <div class="technological-box4">
      <div class="box4-ul">
        <div class="box4-li" v-for="item in list1">
          <div class="box4-li-header flex">{{item.type}}<span style="margin-left: 32px">{{item.code}}</span></div>
          <div class="box4-li-content  flex-center" :title="item.digest">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="technological-box5 technological-box5s">
      <div class="box5-title">团队荣誉</div>
      <el-carousel :interval="4000" :indicator-position="'none'" height="7rem">
        <el-carousel-item style="box-shadow: 0px 3px 36px 1px rgba(0,0,0,0.1000);">
          <img style="width: 100%;object-fit: cover" src="@/assets/imgs/technological/6.png"/>
          <div class="box5-title2">科技进步奖——锚杆（索）锚质量无损检测技术与仪器开发</div>
        </el-carousel-item>
        <el-carousel-item style="box-shadow: 0px 3px 36px 1px rgba(0,0,0,0.1000);">
          <img style="width: 100%;object-fit: cover" src="@/assets/imgs/technological/7.png"/>
          <div class="box5-title2">科技进步奖——锚杆（索）锚质量无损检测技术与仪器开发</div>
        </el-carousel-item>
        <el-carousel-item style="box-shadow: 0px 3px 36px 1px rgba(0,0,0,0.1000);">
          <img style="width: 100%;object-fit: cover" src="@/assets/imgs/technological/8.png"/>
          <div class="box5-title2">科技进步奖——锚杆（索）锚质量无损检测技术与仪器开发</div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";

  export default {
    name: 'wapTechnological',
    components: {headers, footers},
    data() {
      return {
        selectIndex1: 1,
        pageIndex1: 0,
        list2: [],
        selectIndex2: 1,
        pageIndex2: 0,
        list1: [],
      }
    },
    mounted() {
      this.getScientificList();
      this.getIntellectualList();
    },
    beforeDestroy() {
    },
    methods: {
      //获取科研项目
      getScientificList() {
        axios.get(this.pageUrl + `/scientific-project/page?pageNo=${this.selectIndex2}&pageSize=6`).then(res => {
          this.pageIndex2 = res.data.data.pages;
          res.data.data.list.forEach((item) => {
            item.tag1 = item.tags ? item.tags.split(",") : []
          })
          this.list2 = res.data.data.list;

        })
      },


      //获取知识产权
      getIntellectualList() {
        axios.get(this.pageUrl + `/intellectual-right/page?pageNo=${this.selectIndex1}&pageSize=6`).then(res => {
          this.pageIndex1 = res.data.data.pages;
          this.list1 = res.data.data.list;
        })
      }
    }
  }
</script>
<style>
  .technological-box5s .el-carousel__item {
    box-shadow: none !important
  }

  .technological-box6 .el-carousel__item--card.is-active {
    transform: translateX(5%) scale(1) !important;
    width: 90%;
  }
</style>
<style scoped>
  .technological-banner {
    width: 100%;
    height: 13.34rem;
    padding-top: 1rem;
    box-sizing: border-box;
    background-color: #19203B;
    background-image: url("../../assets/imgs/wap/4.png");
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
  }

  .technological-banner .sp1 {
    font-size: 0.48rem;
    font-family: PingFang SC-Bold, PingFang SC;
    width: 80%;
    font-weight: bold;
    color: #19203b;
    margin: 1.34rem 0 0.44rem;
    animation-name: fadeInUp;
    padding:0 0.68rem;
    animation-duration: 1s;
    animation-timing-function: ease;
  }

  .technological-banner .sp2 {
    width: 5.8rem;
    font-size: 0.32rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203b;
    padding:0 0.68rem;
    margin: 0.36rem 0;
    animation-name: fadeInUp;
    animation-duration: 1s;
    animation-delay: 1s;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
    line-height: 2;
    opacity: 0;
  }

  .technological1 {
    background-color: #FFFFFF;
    width: 100%;
    padding: 0.6rem 0.72rem;
    box-sizing: border-box;
  }

  .technological1 .title1 {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    text-align: center;
  }

  .technological1 .content1 {
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 0.4rem;
    letter-spacing: 2px;
    line-height: 1.6;
  }

  .technological-box1-t1 {
    font-size: 0.24rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
    position: relative;
  }

  .technological1 .img1 {
    width: 1.6rem;
  }

  .technological1 .img2, .technological1 .img3 {
    width: 0.8rem;
    position: absolute;
  }

  .technological-box2 {
    width: 100%;
    height: 21.88rem;
    background-image: url("../../assets/imgs/wap/23.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 0.2rem 0.72rem;
  }

  .technological-box2 .box2-t1 {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    text-align: center;
    color: #FFFFFF;
  }

  .technological-box2 .box2-ul {
    margin-top: 0.6rem;
  }

  .technological-box2 .box2-li {
    border-radius: 0.16rem;
    overflow: hidden;
    margin-bottom: 0.4rem;
  }

  .technological-box2 .box2-li .box2-li-header {
    font-size: 0.36rem;
    height: 1.2rem;
    width: 100%;
    padding: 0 0.34rem;
    box-sizing: border-box;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    background-color: rgba(25, 32, 59, 1);
    height: 1.2rem;
  }

  .technological-box2 .box2-li .line {
    width: 0.02rem;
    margin: 0 0.6rem;
    background-color: #FFFFFF;
    height: .52rem;
  }

  .technological-box2 .box2-li ul {
    font-size: 0.36rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    padding: 0.4rem 0;
    box-sizing: border-box;
    background-color: #ffffff3b;
    margin: 0;
  }

  .technological-box2 .box2-li ul li {
    margin-bottom: 0.2rem;
    position: relative;
    padding-left: 0.6rem;
    width: 4.52rem;
  }

  .technological-box2 .box2-li ul li:after {
    content: " ";
    width: 0.16rem;
    height: 0.16rem;
    position: absolute;
    left: 0.2rem;
    top: 0.2rem;
    background-color: rgba(0, 113, 239, 1);
    border-radius: 50%;
  }

  .technological-box3 .img1 {
    width: 100%;
    height: 6.68rem;
    margin-top: 0.4rem;
  }

  .technological-box3 .img2 {
    width: 100%;
    height: 5.6rem;
    object-fit: cover;
  }

  .technological-box7 {
    margin-top: 0.3rem;
  }

  .technological-box7 .box7-title {
    font-size: 0.36rem;
    text-align: center;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    margin-bottom: 0.4rem;
  }

  .technological-box7 .box7-ul {
    display: -webkit-inline-box;
    width: 100%;
    padding: 0 0.4rem;
    box-sizing: border-box;
    overflow: auto;
  }

  .technological-box7 .box7-ul .box7-li {
    width: 6.06rem;
    height: 2.96rem;
    position: relative;
    font-size: 0.24rem;
    background: #F1F3F9;
    margin-right: .2rem;
  }

  .technological-box7 .box7-ul .box7-li img {
    width: 1.5rem;
    height: 0.7rem;
  }

  .technological-box7 .box7-ul .box7-li .text1 {
    font-size: 0.24rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    position: absolute;
    top: 0.2rem;
    left: 0.3rem;
  }

  .technological-box7 .box7-ul .box7-li .box7-li-text {
    width: 4.62rem;
    font-size: 0.32rem;
    margin: 0.2rem auto;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #0071EF;
  }

  .technological-box7 .box7-ul .box7-li .box7-li-text2 {
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    width: 4.62rem;
    margin: 0.2rem auto;
  }

  .technological-box4 {
    margin-top: 0.6rem
  }

  .technological-box4 .box4-li-header {
    width: 6.04rem;
    display: flex;
    align-items: center;
    border-radius: 0.2rem 0.2rem 0 0;
    height: 1rem;
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    background: #308BF1;
    padding: 0 0.4rem;
    box-sizing: border-box;
  }

  .technological-box4 .box4-ul {
    display: -webkit-inline-box;
    width: 100%;
    overflow: auto;
    padding: 0 0.4rem;
    box-sizing: border-box;
  }

  .technological-box4 .box4-li {
    margin-right: 0.2rem;
  }

  .technological-box4 .box4-li-content {
    width: 6.04rem;
    height: 1.9rem;
    font-size: 0.32rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
    padding: 0.4rem;
    background-color: rgba(241, 243, 249, 1);
    box-sizing: border-box;
  }

  .technological-box5 .box5-title {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    text-align: center;
    font-weight: bold;
    margin: 0.5rem 0;
    color: #19203B;
  }

  .technological-box5 .box5-title2 {
    font-size: 0.28rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    width: 5.66rem;
    margin: 0.1rem auto 0;
    text-align: center;
    color: #19203B;
  }

  .technological-box6 {
    padding-bottom: 0.66rem;
  }

  .technological-box6 .box6-title {
    font-size: 0.36rem;
    text-align: center;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-title2 {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #0071EF;
    text-align: center;
    margin-top: 0.6rem;
  }

  .technological-box6 .box6-title1 {
    font-size: 0.28rem;
    text-align: center;
    margin-top: 0.1rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
  }

  .technological-box6 .box6-title3 {
    font-size: 1.6rem;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #0071EF;
    text-align: center;
  }

  .technological-box6 .box6-line {
    width: 6.04rem;
    height: 0.02rem;
    background: #5C5D5F;
    margin: 0.4rem auto;
  }

  .technological-box6 .box6-li {
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box6-box1 {
    padding: 0 0.4rem;
    width: 100%;
    box-sizing: border-box;
  }

  .technological-box6 .li6-2 {
    font-size: 0.8rem;
    font-family: DIN Alternate-Bold, DIN Alternate;
    font-weight: bold;
    color: #19203B;
  }

  .technological-box6 .box-img {
    margin-top: 0.4rem;
  }

  .technological-box6 .box-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/view/technological/wapIndex.vue